module.exports = {
      id: "loading-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "svg-sprite-f7c87499d4b6955c7faa356accbb279e.svg#loading",
      toString: function () {
        return this.url;
      }
    }